export const mathRandom = () => Math.random().toString().split('.')[1];

export const PARTICLE_BACKGROUND = {
    particles: {
        number: {
            value: 150,
        },
        color: {
            value: [
                '#BD10E0',
                '#B8E986',
                '#50E3C2',
                '#FFD300',
                '#E86363'
            ]
        },
        shape: {
            type: ['circle', 'stars'],
            stroke: {
                width: 0,
                color: '#000'
            },
            polygon: {
                nb_sides: 6
            },
            image: {
                src: 'data:image/svg+xml;base64,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',
                width: 100,
                height: 100
            }
        },
        opacity: {
            value: 0.48927153781200905,
            random: false,
            anim: {
                enable: true,
                speed: 0.5,
                opacity_min: 0,
                sync: false
            }
        },
        size: {
            value: 5,
            random: true,
            anim: {
                enable: true,
                speed: 3,
                size_min: 0,
                sync: false
            }
        },
        line_linked: {
            enable: false,
            distance: 150,
            color: '#ffffff',
            opacity: 0.4,
            width: 1
        },
        move: {
            enable: true,
            speed: 0.5,
            direction: 'none',
            random: true,
            straight: false,
            out_mode: 'out',
            bounce: false,
            attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200
            }
        }
    },
    interactivity: {
        detect_on: 'canvas',
        events: {
            onhover: {
                enable: true,
                mode: 'bubble'
            },
            onclick: {
                enable: false,
                mode: 'push'
            },
            resize: true
        },
        modes: {
            grab: {
                distance: 400,
                line_linked: {
                    opacity: 1
                }
            },
            bubble: {
                distance: 83.91608391608392,
                size: 1,
                duration: 3,
                opacity: 1,
                speed: 3
            },
            repulse: {
                distance: 200,
                duration: 0.4
            },
            push: {
                particles_nb: 4
            },
            remove: {
                particles_nb: 2
            }
        }
    },
    retina_detect: true
};
